// this  app is mounted in app/views/ports/_edit.html.erb

import React from 'react';
import ReactDOM from 'react-dom';

import { TokenDetail } from './token';
import { PortDetail } from './port';


$(function () {
  ReactDOM.render(
    PT.port.tokenAuth ? <TokenDetail destination={PT.port} /> : <PortDetail destination={PT.port} />,
    document.getElementById('destination-detail')
  )
})